import React, { Component } from "react";
import { connect } from "react-redux";
import {
  getAdminDashboardTodo,
  getAdminProjectsOverview,
  getAdminMembersOverview,
  getAdminWeeklyProjects,
  getAdminWeeklyUsers
} from "../../../../actions/admin.actions";
import AdminDashboard from "../components/AdminDashboard";

class AdminDashboardContainer extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.getAdminProjectsOverview();
    this.props.getAdminDashboardTodo();
    this.props.getAdminMembersOverview();
    this.props.getAdminWeeklyProjects();
    this.props.getAdminWeeklyUsers();
  }

  render() {
    return (
      <AdminDashboard
        projectsOverview={this.props.projectsOverview}
        todo={this.props.todo}
        membersOverview={this.props.membersOverview}
        weeklyProjects={this.props.weeklyProjects}
        weeklyUsers={this.props.weeklyUsers}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    projectsOverview: state.admin.projectsOverview,
    todo: state.admin.todo,
    membersOverview: state.admin.membersOverview,
    weeklyProjects: state.admin.weeklyProjects,
    weeklyUsers: state.admin.weeklyUsers
  };
};

const mapDispatchToProps = dispatch => ({
  getAdminDashboardTodo: () => dispatch(getAdminDashboardTodo()),
  getAdminProjectsOverview: () => dispatch(getAdminProjectsOverview()),
  getAdminMembersOverview: () => dispatch(getAdminMembersOverview()),
  getAdminWeeklyProjects: () => dispatch(getAdminWeeklyProjects()),
  getAdminWeeklyUsers: () => dispatch(getAdminWeeklyUsers())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminDashboardContainer);



// WEBPACK FOOTER //
// ./src/routes/admin/dashboard/containers/AdminDashboardContainer.js